import {SerializedSankeyBreakdown, SerializedSankeySegment} from './serialized';

export class SankeyBreakdown {
  public declare segments: SerializedSankeySegment[];
  public declare totalCount: number;
  public declare timePercentilesFromPrev: number[];
  public declare timePercentilesFromStart: number[];
  private declare breakdownColor: {primary: string; secondary: string};

  constructor({segments, totalCount, timePercentilesFromPrev, timePercentilesFromStart}: SerializedSankeyBreakdown) {
    this.segments = segments || [];
    this.totalCount = Number(totalCount);
    this.timePercentilesFromPrev = timePercentilesFromPrev || [];
    this.timePercentilesFromStart = timePercentilesFromStart || [];
  }

  get id() {
    return this.segments
      .map((segment) => segment.label.length + segment.label + segment.values.map((v) => v.length + v).join())
      .join();
  }

  set color(breakdownColor: {primary: string; secondary: string}) {
    this.breakdownColor = breakdownColor;
  }

  get color() {
    return this.breakdownColor;
  }
}
